/**
 * tm/portal-ui/preview.tsx — 대표님 · 팀장님 화면 「미리 보기」(?preview=1) 공용 (2026-10-28 지도사 「대표님 · 팀장님 화면이 어떻게 보이는지 · 바로 보기 눌러 창 하나 더 · 거기서 URL 복사도」)
 *  미리 보기로 열면: 맨 위 띠(누구 화면인지 · 누른 것은 남지 않음 · 「주소 복사」= 미리 보기 표시를 뺀 진짜 주소) · 연 기록 · 답한 기록은 남기지 않는다(화면이 PREVIEW 를 보고 막음)
 */
import { useState } from 'react';

export const PREVIEW = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('preview') === '1';

/** 미리 보기 표시를 뺀 진짜 주소 — 대표님 · 팀장님께 보내는 그 주소 */
export function realUrl(): string {
  try { const u = new URL(window.location.href); u.searchParams.delete('preview'); return u.toString(); } catch (e) { return window.location.href; }
}

export function PreviewBar({ who }: { who: '대표님' | '팀장님' }) {
  const [msg, setMsg] = useState('');
  if (!PREVIEW) return null;
  const copy = async () => {
    const url = realUrl();
    try { await navigator.clipboard.writeText(url); setMsg('복사했어요'); } catch (e) { setMsg(url); }
    window.setTimeout(() => setMsg(''), 4000);
  };
  return (
    <div role="status" style={{ position: 'sticky', top: 0, zIndex: 30, background: '#0B1526', color: '#fff', fontSize: 14, lineHeight: 1.5, padding: '8px 12px 8px 16px', display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', wordBreak: 'keep-all' }}>
      <span style={{ flex: '1 1 220px', minWidth: 0 }}>{who} 화면 미리 보기 · 여기서 누른 것은 남지 않아요</span>
      {msg && msg !== '복사했어요' ? <input readOnly value={msg} onFocus={e => e.currentTarget.select()} aria-label="주소" style={{ flex: '1 1 220px', minWidth: 0, height: 32, borderRadius: 8, border: 'none', padding: '0 8px', fontSize: 13 }} /> : null}
      <button type="button" onClick={() => void copy()} style={{ flexShrink: 0, height: 32, padding: '0 14px', borderRadius: 8, border: 'none', background: '#fff', color: '#0B1526', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>{msg === '복사했어요' ? '복사했어요' : '주소 복사'}</button>
    </div>
  );
}
